const jobs = {
  bulk: {

    table: {
      direction: {
        to: 'Distribuir',
        from: 'Recoger',
        both: 'Recoger/Distribuir',
      },
    },

    direction: {
      label: 'Dirección',
      to: 'Hacia trabajo',
      from: 'Del trabajo',
      both: 'Hacia trabajo / desde el trabajo',
    },

    form: {
      information: {
        passengers: {
          header: 'Seleccionar empleados',
          fields: {
            passengers: 'Empleados',
          },
        },

        details: {
          fields: {
            direction: 'Seleccionar dirección',
            shift: 'Horas de trabajo'
          },
        },
        locations: {
          header: 'Lugar de Trabajo',
          fields: {
            locations: 'Seleccionar Lugar de Trabajo'
          }
        },
      },
    },
  },
};

export default jobs;
